




import { ROUTES } from "@/constants/routes";
import Vue from "vue";

export default Vue.extend({
  name: "CatchSession",
  beforeMount(): void {
    const webId=decodeURIComponent(this.$route.params.cookie);
    this.$store.dispatch("saveSessionId", this.$route.params.id);
    this.$store.dispatch("saveWebId", webId);
    this.$router.push(ROUTES.HOME.path);
  },
});
